import './ValidatedSelectInput.scss';
import { TranslationKey } from '@Localization';
import { AutocompleteProps } from '@mui/joy';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { Select } from '../../design/inputs/select/Select';
import { S_FieldLabel } from '../../design/labels/fieldLabel/S_FIeldLabel';
import { Feedback } from './Feedback';

interface IValidatedSelectInputProps<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
> extends AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {
  isValid?: boolean;
  feedbacks?: TranslationKey[];
  labelText?: string;
  feedbackParams?: Record<string, string | number>;
}

export const ValidatedSelectInput = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = true,
  FreeSolo extends boolean | undefined = false,
>({
  isValid,
  className,
  labelText,
  required,
  feedbacks,
  feedbackParams,
  ...rest
}: IValidatedSelectInputProps<T, Multiple, DisableClearable, FreeSolo>): ReactElement => {
  let validationClass = '';
  if (isValid !== undefined) {
    validationClass = isValid ? 'is-valid' : 'is-invalid';
  }

  return (
    <div className={classNames('validated-select-input', className)}>
      <div>
        {labelText && (
          <S_FieldLabel
            isRequired={required}
            text={labelText}
          />
        )}
        <Select
          className={validationClass}
          required={required}
          {...rest}
        />
        <Feedback
          feedbacks={feedbacks}
          feedbackParams={feedbackParams}
        />
      </div>
    </div>
  );
};
